import React, { useEffect, useRef, useState } from "react";
import Quill from "quill";
import "quill/dist/quill.snow.css";

const defaultToolbar = [
  [{ header: [1, 2, 3, false] }],
  ["bold", "italic", "underline", "strike"],
  [{ list: "ordered" }, { list: "bullet" }],
  [{ indent: "-1" }, { indent: "+1" }],
  ["link", "blockquote", "code-block"],
  [{ align: [] }],
  ["clean"]
];

const INITIAL_HTML = "<p>Hello! Start writing here.</p>";

function ClassicText() {
  const hostRef = useRef<HTMLDivElement | null>(null);
  const [, setHtml] = useState(INITIAL_HTML);

  useEffect(() => {
    const container = hostRef.current;
    if (!container) return;

    container.innerHTML = INITIAL_HTML.trim();

    const quill = new Quill(container, {
      theme: "snow",
      modules: {
        toolbar: defaultToolbar
      }
    });
    const onTextChange = () => {
      setHtml(quill.getSemanticHTML());
    };
    quill.on(Quill.events.TEXT_CHANGE, onTextChange);

    return () => {
      quill.off(Quill.events.TEXT_CHANGE, onTextChange);

      const toolbar = container.previousElementSibling;
      if (toolbar?.classList?.contains("ql-toolbar")) {
        toolbar.remove();
      }
      container.classList.remove("ql-container", "ql-snow");
      container.innerHTML = "";
    };
  }, []);

  return (
    <div className="rich-editor-root">
      <div ref={hostRef} className="quill-editor-host" />
    </div>
  );
}

export default ClassicText;
